module.exports = __webpack_public_path__ + "img/m-banner-vbrohihj-ru-RU.c494e6d9.jpg";